import { Immutable } from '@openfin/predux';
import { NotificationInternal } from 'src/client/internal';
import { ValidateOptions } from 'yup/lib/types';
import { TemplateCustom } from '../../../client/templates/templates';
import { flattenLayout } from './flattenLayout';
import { isTemplate } from '../../model/templates/isTemplate';

export function getUpdateValidateOptions(
  notification?: Immutable<NotificationInternal>
): ValidateOptions | undefined {
  if (notification && isTemplate<TemplateCustom>(notification, 'custom')) {
    const compositions = notification.templateOptions.body.compositions;
    if (compositions.length > 0) {
      return {
        context: {
          fragments: flattenLayout(compositions[0].layout),
        },
      };
    }
  }
  return undefined;
}
